export default {
    buttons: {
        lecture: '선생님과',
        self: '자기주도',
    },
    moduleLabel: {
        cardWriting: '와글와글 💬️',
        wordCheck: '단어 추리하기',
        wordWriting: '받아쓰기',
        wordSelection: '단어 고르기',
        seedLetter: '씨앗글자',
        oxQuiz: 'OX 퀴즈',
        fillInTheBlanks: '빈칸 채우기',
        proConDebate: '찬반 토론',
        segmentedReading: '차근차근 읽기',
        sentenceOrdering: '순서 맞추기',
        correctTheMistakes: '고쳐 쓰기',
        postIt: '표 완성하기',
        magicWordTest: '알아요! 몰라요?',
    },
};
